export default () => {
    const appHeight = () => {
        const doc = document.documentElement
        doc.style.setProperty('--app-height', `${window.innerHeight}px`)
    }

    // Detect iPhone in-app browsers; don't update app-height for those
    if (!(navigator.userAgent.indexOf('AppleWebKit') &&
      (
        navigator.userAgent.indexOf('Instagram') ||
        navigator.userAgent.indexOf('LinkedInApp') ||
        navigator.userAgent.indexOf('FBAN') || navigator.userAgent.indexOf('FBAV') // Facebook
      ))
    ) {
        window.addEventListener('resize', appHeight)
    }

    appHeight()
}
